import React from 'react'

import './styles.scss'

const SPECIAL_OFFER = 9.99

const Offer = ({ onResubscriptionBtnClick, onCancelSubscriptionBtnClick }) => {
	return (
		<div className="unsubscribe-offer">
			<h2 className="unsubscribe-offer__title">
				Thanks for your feedback.
				<br />
				<span className="accent--pink">Take your gift!</span>
			</h2>
			<img
				src="/images/unsubscribe/man-with-discount.png"
				alt="70% OFF offer."
				className="unsubscribe-offer__image"
			/>
			<p className="unsubscribe-offer__description">
				Lifetime Access for{' '}
				<span className="accent--pink">${SPECIAL_OFFER}</span>
			</p>
			<button
				className="unsubscribe-offer__resubscribe-btn"
				onClick={onResubscriptionBtnClick}
			>
				Unsubscribe and
				<br /> get Lifetime Access for ${SPECIAL_OFFER}
			</button>
			<button
				className="unsubscribe-offer__unsubscribe-btn"
				onClick={onCancelSubscriptionBtnClick}
			>
				Cancel Subscription Anyway
			</button>
		</div>
	)
}

export { Offer }
